'use strict'

const formatDate = (dateString, locale = 'en-US') => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat(locale, { month: 'long', day: 'numeric', year: 'numeric' }).format(date);
}

export {formatDate}
